import Butter from 'buttercms'
import { CITY_COLLECTION_KEY } from './constants'

/**
 * The ButterCMS readonly token pre-existed as env var NEXT_PUBLIC_FIRESIDE_API_KEY
 * So reusing that here.
 */
const token = process.env.NEXT_PUBLIC_FIRESIDE_API_KEY
const butter = Butter(token)

export interface City {
  state: string
  city: string
}

const fetchCities = async (): Promise<City[]> => {
  const params = {
    // Set the page size super high because ButterCMS requires pagination
    // and we want all of the city records.
    page_size: 9999,
  }
  const response = await butter.content.retrieve(['se-friendly_cities'], params)
  const cityData = response.data.data[CITY_COLLECTION_KEY]
  const cities = cityData.map((c: City) => ({
    city: c.city,
    state: c.state,
  }))

  return cities
}

export default fetchCities
